/*
  Notch 7 (Oct 2026): when a shopper changes an option (e.g. Color) and their previously picked
  Size doesn't exist in the new color (Yam S -> Bright Orange), Dawn lands on a non-existent combo
  and shows "Unavailable". This auto-selects the first size that exists (in stock first).
*/
(function () {
  function check(root) {
    var vs = root.querySelector('variant-selects');
    if (!vs) return;
    var data = vs.querySelector('[data-selected-variant]');
    if (!data) return;
    if (data.textContent.trim() !== 'null') { root._n7Tries = 0; return; }
    if ((root._n7Tries || 0) >= 3) return;
    var sets = vs.querySelectorAll('fieldset');
    var last = sets[sets.length - 1];
    if (!last) return;
    var pick = last.querySelector('input[type="radio"]:not(:checked):not(.disabled)') ||
               last.querySelector('input[type="radio"]:not(:checked)');
    if (pick) { root._n7Tries = (root._n7Tries || 0) + 1; pick.click(); }
  }
  function init() {
    document.querySelectorAll('product-info').forEach(function (pi) {
      if (pi._n7Observed) return;
      pi._n7Observed = true;
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { check(pi); }, 60);
      }).observe(pi, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
